import styled from "@emotion/styled/macro";

const FormField = styled("div")`
  margin-top: 6px;

  label {
    display: block;
    padding: 0 12px;
    font-weight: bold;
    font-size: 14px;
  }
`;

export default FormField;
